import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/* stylelint-disable no-descending-specificity */

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { white, gray10, gray25, gray40, gray75, gray90, gray95, spacer8, spacer12, spacer24, spacer4 } from '@spotify-internal/encore-foundation';
import { buttonReset, typeStyleH4 } from "../../styles";
import PopoverMobile from "../PopoverNavigation/PopoverMobile";
import PopoverDesktop from "../PopoverNavigation/PopoverDesktop";
import PopoverNavigationItem from "../PopoverNavigationItem";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.popover === 'dark';
};

var propTypes = {
  component: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string, PropTypes.func])
};
var defaultProps = {
  component: 'a'
};
var PopoverNavigationLink = styled(function (_ref) {
  var Component = _ref.component,
      props = _objectWithoutProperties(_ref, ["component"]);

  return React.createElement(Component, props);
}).withConfig({
  displayName: "PopoverNavigationLink",
  componentId: "sc-5o5310-0"
})(["", ";color:", ";text-decoration:none;display:inline-block;", " &{border-radius:", ";display:block;padding:10px ", ";margin-left:-", ";margin-right:-", ";&:hover{background-color:", ";}&:active,&:focus{&,&:hover{background-color:", ";}}", ";}", " ", ":first-child &{margin-top:-", ";}", " ", ":last-child &{margin-bottom:-", ";}", " &{", ";padding-bottom:", ";padding-top:", ";}&:hover{color:", ";}&:active,&:focus{&,&:hover{outline:none;color:", ";}}"], function (props) {
  return props.component === 'button' && css(["", ";"], buttonReset({
    lineHeight: 'inherit'
  }));
}, function (props) {
  return isDarkTheme(props) ? gray75 : gray40;
}, PopoverDesktop, spacer4, spacer8, function (props) {
  return isDarkTheme(props) ? '13px' : spacer12;
}, function (props) {
  return isDarkTheme(props) ? '13px' : spacer12;
}, function (props) {
  return isDarkTheme(props) ? gray40 : gray95;
}, function (props) {
  return isDarkTheme(props) ? gray25 : gray90;
}, function (props) {
  return props.component === 'button' && css(["width:calc(100% + ", ");text-align:left;"], isDarkTheme(props) ? '26px' : spacer24);
}, PopoverDesktop, PopoverNavigationItem, spacer8, PopoverDesktop, PopoverNavigationItem, spacer8, PopoverMobile, typeStyleH4(), spacer12, spacer12, function (props) {
  return isDarkTheme(props) ? white : gray10;
}, function (props) {
  return isDarkTheme(props) ? white : gray10;
});
PopoverNavigationLink.propTypes = propTypes;
PopoverNavigationLink.defaultProps = defaultProps;
export default PopoverNavigationLink;